import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

let reactPlugin = null
let appInsights = null

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
  /**
   * Initialize the Application Insights class
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
   * @return {void}
   */
  const initialize = ( instrumentationKey, browserHistory, role ) => {
    if ( !browserHistory ) {
      throw new Error( 'Could not initialize Telemetry Service' )
    }
    if ( !instrumentationKey ) {
      throw new Error(
        'Instrumentation key not provided in ./src/TelemetryProvider.js'
      )
    }

    reactPlugin = new ReactPlugin()

    appInsights = new ApplicationInsights( {
      config: {
        instrumentationKey: instrumentationKey,
        maxBatchInterval: 1000, 
        extensions: [ reactPlugin ],
        extensionConfig: {
          [ reactPlugin.identifier ]: {
            history: browserHistory,
          },
        }
      },
    } )

    appInsights.loadAppInsights()

    appInsights.addTelemetryInitializer( ( envelope ) => {
      envelope.tags = envelope.tags || []
      envelope.tags.push( { 'ai.cloud.role': role } )
    } )
  }

  return { reactPlugin, appInsights, initialize }
}

export const ai = createTelemetryService()
export const getAppInsights = () => appInsights
export const trackEventMessage = e => {
    try {
        appInsights = getAppInsights()
        if( appInsights && appInsights.trackEvent&&e ) {
            appInsights.trackEvent( e )
        }
    }catch( ex ){
        console.error( ex )
    }
}
export const trackEventMessageFailure = ( e, ex ) => {
  try {
      appInsights = getAppInsights()
      if( appInsights && appInsights.trackEvent ) {
          if ( e ) 
            appInsights.trackEvent( e )
          if( ex && appInsights.trackException ){
            appInsights.trackException( new Error( JSON.stringify( ex ) ) )
          }
      }
  }catch( exc ){
      console.error( exc )
  }
}